import palette from '../palette';

export default {
  root: {
    display: "table-row",
    paddingTop: 5,
    paddingBottom: 5,
    "&:hover": {
      backgroundColor: palette.action.hover,
    },
  },
  head: {
    backgroundColor: palette.background.header,
    paddingTop: 5,
    paddingBottom: 5,
    marginLeft: 5,
    marginRight: 5,
  },
  footer: {}
};
